import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import zIndex from 'material-ui/styles/zIndex';

import Theme from './Theme';

export default createMuiTheme({
  palette: {
    primary: {
      main: Theme.colors.primary.normal,
      contrastText: Theme.colors.text.tertiary,
    },
    secondary: {
      main: Theme.colors.secondary,
      contrastText: Theme.colors.text.tertiary,
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: Theme.fonts.family,
    button: {
      fontSize: Theme.fonts.button.size,
      fontWeight: Theme.fonts.button.weight,
      letterSpacing: Theme.fonts.button.letterSpacing,
    },
  },
  zIndex,
});



// WEBPACK FOOTER //
// ./src/statsradio/themes/v3/MuiTheme.js